export const validationMessages = [
    { name: 'required', message: 'Enter a Value' },
    { name: 'validationExpression', message: 'Must match validation expression of attribute'}
];
